// extracted by mini-css-extract-plugin
module.exports = {"news":"Informations_news__1kw7q","table":"Informations_table__1PonL","actions":"Informations_actions__Iqps5"};